<template>
  <div>
    <a-spin :spinning="loading">
      <div class="custom-padding-bottom-10px">
        <div class="total">
          {{ total }}
        </div>

        <div
          ref="ageRangeStatisticsChart"
          style="height: 200px;"
        />
      </div>
    </a-spin>
  </div>
</template>

<script>
import { findDeathStatistics } from '@/api/death_statistic'

export default {
  // 性别统计图
  name: 'AgeRangeStatisticsChart',
  data() {
    return {
      loading: true,
      data: [],
      // 图表
      chart: null,
      // 总数
      total: 0
    }
  },
  mounted() {
    this.fetchData()
  },
  computed: {
    // 图表默认配置
    chartOption() {
      return {
        // 标题
        title: {
          text: '年龄分布',
          bottom: 0,
          left: 'center',
          padding: [20, 0, 0, 0]
        },
        // 提示框
        tooltip: {
          trigger: 'item',
          formatter: (params) => {
            return params.marker + this.$lodash.truncate(params.data.name, { length: 6 }) +
              '&nbsp;&nbsp;' + params.value + '人'
          }
        },
        // 图例
        legend: {
          orient: 'vertical',
          top: 'middle',
          right: 0
        },
        // 数据组
        series: [
          {
            avoidLabelOverlap: false,
            label: { show: false },
            labelLine: { show: true },
            type: 'pie',
            radius: ['50%', '70%'],
            data: [],
            left: 'center'
          }
        ]
      }
    }
  },
  methods: {
    // 绘制图表
    drawChart() {
      this.chart ||= this.$echarts.init(this.$refs.ageRangeStatisticsChart, 'echarts_custom')
      this.chartOption.series[0].data = []
      for (let i = 0; i < this.data.length; i++) {
        const statistic = this.data[i]
        this.chartOption.series[0].data[i] = {
          name: this.$lodash.truncate(statistic.name, { length: 6 }),
          value: statistic.count
        }
      }
      // 全部重新加载-解决tooltip.formatter params不更新的问题
      this.chart.setOption(this.chartOption, true)
      // 添加表格自适应
      window.addEventListener('resize', () => {
        this.chart.resize()
      })
    },

    fetchData() {
      this.loading = true
      this.total = 0
      findDeathStatistics(Object.assign({ type: 'age_range' })).then((res) => {
        if (res.code === 0) {
          this.data = res.data
          for (let i = 0; i < this.data.length; i++) {
            this.total += this.data[i].count
          }
          this.drawChart()
        }
        this.loading = false
      })
    }
  },
  watch: {
    // 监听间隔时间
    intervalTime() {
      this.fetchData()
    }
  },
  beforeDestroy() {
    // 移除chart表格自适应监听
    window.removeEventListener('resize', () => {
      this.chart.resize()
    })
  }
}
</script>

<style lang="less" scoped>
.total {
  width: 100%;
  font-size: 30px;
  position: absolute;
  top: 38%;
  text-align: center;
}
</style>
